import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff1ffe88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ff1ffe88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1ffe88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1ffe88')) {
      api.createRecord('ff1ffe88', component.options)
    } else {
      api.reload('ff1ffe88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ff1ffe88&scoped=true", function () {
      api.rerender('ff1ffe88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/points-mall/index.vue"
export default component.exports